import React, { useState } from 'react';
import GlobalDialog from '../../../components/mui/Dialogue/GlobalDialog';
import {
  AddButton,
  CancelButton,
  EditButton,
  SubmitButton,
  UpdateButton,
} from '../../../components/mui/Buttons/Buttons';
import { Form, FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';
import { Autocomplete, Box, LinearProgress, Stack, TextField } from '@mui/material';
import GlobalSelectField from '../../../components/mui/GlobalSelectField';
import { useDispatch, useSelector } from 'react-redux';
import { addProspectLead, getProspectLeadsTable, updateProspectLead } from '../../../redux/features/globalSlice';
import useHandleApiResponse from '../../../Hooks/useHandleApiResponse';
import { prospect_leads_departments } from '../../../utils/constants/departmentDetails';
import { project } from '../../../utils/constants/project';

export const statusOptions = [
  { id: 1, name: 'Call Attended' },
  { id: 2, name: 'Admission Done' },
  { id: 3, name: 'Assessment Done' },
];

export const genders = [
  { id: 1, name: 'Male' },
  { id: 2, name: 'Female' },
];

export const assignOptions = [
  { id: 'ALL', name: 'ALL' },
  { id: 'CSD', name: 'CSD' },
  { id: 'OGD', name: 'OGD' },
];

const ProspectLeadAddEdit = ({ row, onClose }) => {
  const dispatch = useDispatch();
  const { loading: globalLoading } = useSelector((state) => state.global);
  const { loading: deoLoading, syllabuses, classes } = useSelector((store) => store.deo);

  const [open, setOpen] = useState(false);
  const handleApiResponse = useHandleApiResponse();
  const initialValues = {
    name: row ? row.name : '',
    // age: row ? row.age : '',
    // place: row ? row.place : '',
    email: row ? row.email : '',
    // phone_number: row?.phone ?? '',
    phone_number: row?.phone ? String(row.phone).replace(/[^0-9]/g, '') : '',
    country_code: row?.country_code ?? '91',
    alternative_country_code: row?.alternative_country_code ?? '',
    alternative_phone: row?.alternative_phone ?? '',
    class_id: row ? row.classId : '',
    syllabus_id: row ? row.syllabusId : '',
    // gender: row ? (row.gender === 'Male' ? 1 : 2) : '',
    department_id: row?.current_department_id ?? '',
    // status: row?.current_status_id ?? '',
    parentName: row ? row.lead_father_name : '',
    place: row ? row?.lead_place : '',
    project: row ? row?.project : '',
  };

  const schema = Yup.object({
    name: Yup.string().required('Name is required'),
    // age: Yup.number().required('Age is required'),
    // place: Yup.string().required('Place is required'),
    email: Yup.string().email('Invalid email format').nullable().notRequired(),
    phone_number: Yup.number().required('Contact number is required'),
    alternative_country_code: Yup.string().nullable(),
    alternative_phone: Yup.string().nullable(),
    class_id: Yup.number().nullable(),
    syllabus_id: Yup.number().nullable(),
    // gender: Yup.mixed().required('Gender is required'),
    country_code: Yup.string().required('Country code is required'),
    department_id: Yup.number().required('Department is required'),
    // status: Yup.mixed().required('Status is required'),

    parentName: Yup.string().nullable(),
    place: Yup.string().nullable(),
    project: Yup.string().nullable(),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: schema,
    onSubmit: async (values) => {
      const payload = {
        name: values.name,
        // email: values.email,
        email: values.email ? values.email : null,
        phone: values.phone_number,
        country_code: values.country_code,

        alternative_country_code: values.alternative_country_code,
        alternative_phone: values.alternative_phone,
        class_id: values.class_id,
        syllabus_id: values.syllabus_id,
        current_department_id: values.department_id,
        lead_father_name: values.parentName,
        lead_place: values.place,
        project: values.project,
      };

      let res;

      if (row) {
        // UPDATE
        res = await dispatch(
          updateProspectLead({
            id: row.prospect_lead_id,
            data: payload,
          }),
        );
      } else {
        // ADD
        res = await dispatch(addProspectLead([payload]));
      }

      // if (res.meta.requestStatus === 'fulfilled') {
      //   formik.resetForm();

      handleApiResponse(res, {
        onSuccess: () => {
          formik.resetForm();

          if (onClose) onClose(true);
        },
        onFailed: () => {
          console.log('Add/Update Failed');
        },
      });
    },
  });

  const handleCancel = () => {
    formik.resetForm();
    if (onClose) onClose(false);
  };

  // const handleChange = (field) => (event, option) => {
  //   formik.setFieldValue(field, option?.id || '');
  // };
  const handleChange = (field) => (event, option) => {
    if (field === 'project') {
      // This ensures Formik stores "Little Genie" instead of 1
      formik.setFieldValue(field, option?.label || '');
    } else {
      formik.setFieldValue(field, option?.id || '');
    }
  };

  console.log('formik', formik);

  return (
    <FormikProvider value={formik}>
      <Form onSubmit={formik.handleSubmit}>
        <Stack spacing={2}>
          <TextField
            fullWidth
            id="name"
            label="Name"
            name="name"
            value={formik.values.name}
            onChange={formik.handleChange}
            error={formik.touched.name && Boolean(formik.errors.name)}
            helperText={formik.touched.name && formik.errors.name}
          />
          {/*
                  <TextField
                    fullWidth
                    type="number"
                    id="age"
                    label="Age"
                    name="age"
                    value={formik.values.age}
                    onChange={formik.handleChange}
                    error={formik.touched.age && Boolean(formik.errors.age)}
                    helperText={formik.touched.age && formik.errors.age}
                    onWheel={(e) => e.target.blur()}
                  /> */}

          {/* <TextField
                    fullWidth
                    id="place"
                    label="Place"
                    name="place"
                    value={formik.values.place}
                    onChange={formik.handleChange}
                    error={formik.touched.place && Boolean(formik.errors.place)}
                    helperText={formik.touched.place && formik.errors.place}
                  /> */}
          <TextField
            fullWidth
            type="email"
            id="email"
            label="Email"
            name="email"
            value={formik.values.email}
            onChange={formik.handleChange}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
          />
          <TextField
            fullWidth
            id="parentName"
            label="Parent Name"
            name="parentName"
            value={formik.values.parentName}
            onChange={formik.handleChange}
            error={formik.touched.parentName && Boolean(formik.errors.parentName)}
            helperText={formik.touched.parentName && formik.errors.parentName}
          />
          <TextField
            fullWidth
            id="place"
            label="Place"
            name="place"
            value={formik.values.place}
            onChange={formik.handleChange}
            error={formik.touched.place && Boolean(formik.errors.place)}
            helperText={formik.touched.place && formik.errors.place}
          />
          <Stack direction="row" spacing={1}>
            <TextField
              fullWidth
              id="country_code"
              label="Country Code"
              name="country_code"
              value={formik.values.country_code}
              onChange={formik.handleChange}
              error={formik.touched.country_code && Boolean(formik.errors.country_code)}
              helperText={formik.touched.country_code && formik.errors.country_code}
            />
            <TextField
              fullWidth
              type="number"
              id="phone_number"
              label="Contact Number"
              name="phone_number"
              value={formik.values.phone_number}
              onChange={formik.handleChange}
              error={formik.touched.phone_number && Boolean(formik.errors.phone_number)}
              helperText={formik.touched.phone_number && formik.errors.phone_number}
              onWheel={(e) => e.target.blur()}
            />
          </Stack>

          {/* alternative  */}
          <Stack direction="row" spacing={1}>
            <TextField
              fullWidth
              id="alternative_country_code"
              label="Alternative Country Code"
              name="alternative_country_code"
              value={formik.values.alternative_country_code}
              onChange={formik.handleChange}
              error={formik.touched.alternative_country_code && Boolean(formik.errors.alternative_country_code)}
              helperText={formik.touched.alternative_country_code && formik.errors.alternative_country_code}
            />
            <TextField
              fullWidth
              type="number"
              id="alternative_phone"
              label="Alternative Contact Number"
              name="alternative_phone"
              value={formik.values.alternative_phone}
              onChange={formik.handleChange}
              error={formik.touched.alternative_phone && Boolean(formik.errors.alternative_phone)}
              helperText={formik.touched.alternative_phone && formik.errors.alternative_phone}
              onWheel={(e) => e.target.blur()}
            />
          </Stack>
          <Box>
            <Autocomplete
              disabled={deoLoading}
              name="class_id"
              id="class_id"
              options={classes}
              getOptionLabel={(option) => option.className || ''}
              value={classes?.find((syllabus) => syllabus.id == formik.values.class_id) || null}
              onChange={handleChange('class_id')}
              renderInput={(params) => (
                <TextField
                  // disabled
                  fullWidth
                  autoComplete="off"
                  {...params}
                  label="Class"
                  error={formik.touched.class_id && Boolean(formik.errors.class_id)}
                  helperText={formik.touched.class_id && formik.errors.class_id}
                />
              )}
            />
          </Box>
          <Box>
            <Autocomplete
              disabled={deoLoading}
              name="syllabus_id"
              id="syllabus_id"
              options={syllabuses}
              getOptionLabel={(option) => option.name || ''}
              value={syllabuses?.find((syllabus) => syllabus.id === formik.values.syllabus_id) || null}
              onChange={handleChange('syllabus_id')}
              renderInput={(params) => (
                <TextField
                  // disabled
                  fullWidth
                  autoComplete="off"
                  {...params}
                  label="Syllabus"
                  error={formik.touched.syllabus_id && Boolean(formik.errors.syllabus_id)}
                  helperText={formik.touched.syllabus_id && formik.errors.syllabus_id}
                />
              )}
            />
          </Box>
          <GlobalSelectField
            options={{
              formik,
              label: 'Assigned to Department',
              name: 'department_id',
              data: prospect_leads_departments,
              keys: { id: 'id', value: 'name' },
            }}
            disabled={Boolean(row)}
          />
          <GlobalSelectField
            options={{
              formik,
              label: 'Select Project',
              name: 'project',
              data: project,
              // Keep this as 'label' so the UI displays the string and Formik holds the string
              keys: { id: 'label', value: 'label' },
            }}
          />
          {/*
                  <GlobalSelectField
                    options={{
                      formik,
                      label: 'Gender',
                      name: 'gender',
                      data: genders,
                      keys: { id: 'id', value: 'name' },
                    }}
                  /> */}

          {/* <GlobalSelectField
            options={{
              formik,
              label: 'Status',
              name: 'status',
              data: statusOptions,
              keys: { id: 'id', value: 'name' },
            }}
          /> */}
          {/* Buttons */}
          {(globalLoading || deoLoading) && (
            <Box sx={{ width: '100%' }}>
              <LinearProgress />
            </Box>
          )}

          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
            <Stack direction={'row'} spacing={1}>
              <CancelButton action={handleCancel}>Cancel</CancelButton>

              {row ? (
                <UpdateButton disabled={globalLoading || deoLoading} type="submit">
                  {globalLoading || deoLoading ? 'Updating...' : 'Update'}
                </UpdateButton>
              ) : (
                <SubmitButton disabled={globalLoading || deoLoading} type="submit">
                  {globalLoading || deoLoading ? 'Submitting...' : 'Submit'}
                </SubmitButton>
              )}
            </Stack>
          </Box>
        </Stack>
      </Form>
    </FormikProvider>
  );
};

export default ProspectLeadAddEdit;
